import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "src/assets/img/labasservice2.png";
import { Button, Tooltip } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";

const PDFGenerate = (props) => {
  const { estimationcount, state, details } = props;

  const generatePDF = () => {
    const doc = new jsPDF({ orientation: "p", lineHeight: 1.5 });
    
    // Add logo and header information
    doc.addImage(logo, "PNG", 92, 8, 35, 42);
    doc.setFontSize(18);
    doc.text("Lab Estimation", 89, 63);
    doc.setFontSize(12);

    // Add report details
    doc.text(30, 100, `Report Name: ${estimationcount.reportname}`);
    doc.text(30, 110, `Application: ${estimationcount.application}`);
    doc.text(30, 120, `Number of Trainee: ${estimationcount.no_of_trainee}`);
    doc.text(30, 130, `Start Date and Time: ${estimationcount.start_date}`);
    doc.text(30, 140, `End Date and Time: ${estimationcount.end_date}`);
    doc.text(120, 100, `Training Hours: ${estimationcount.actual_hours} Hrs`);
    doc.text(120, 110, `Storage Hours: ${estimationcount.actual_hours} Hrs`);
    doc.text(120, 120, `Overall App Cost: Rs.${estimationcount.overall_app_price}`);
    doc.text(120, 130, `Overall Machine Cost: Rs.${estimationcount.overall_type_price}`);
    doc.text(120, 140, `Overall Storage Cost: Rs.${estimationcount.overall_storage_price}`);
    doc.text(55, 160, `----- Overall Lab Cost (excluding taxes):   Rs.${estimationcount.total_price} -----`);

    // Prepare table data
    const columns = ["Name", "Spec", "Cost/hrs (INR)"];
    const rows = details.map(invoice => [invoice.name, invoice.spec, invoice.price]);

    // Add autoTable with proper pagination settings
    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 170, // Start position after the header content
      margin: { top: 15 },
      styles: {
        overflow: 'linebreak',
        cellPadding: 2,
        fontSize: 10,
        valign: 'middle',
        halign: 'center'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold',
        valign: 'middle',
        halign: 'center'
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 'auto' },
        2: { cellWidth: 'auto' }
      },
      // This will automatically handle pagination
      didDrawPage: function (data) {
        // Footer text - centered at the bottom
        doc.setFontSize(9);
        const footerText = "Please contact sales@zippyops.com to check and obtain discount eligibility for this lab.";
        const pageWidth = doc.internal.pageSize.width;
        const textWidth = doc.getStringUnitWidth(footerText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xOffset = (pageWidth - textWidth) / 2;
        
        doc.text(
          footerText,
          xOffset,
          doc.internal.pageSize.height - 15
        );
        
        // Page number - right aligned
        doc.setFontSize(7);
        const pageCount = doc.internal.getNumberOfPages();
        doc.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          doc.internal.pageSize.width - 20,
          doc.internal.pageSize.height - 10,
          null,
          null,
          "right"
        );
      }
    });

    doc.save(`${state.reportname}.pdf`);
  };

  return (
    <Tooltip title={estimationcount.total_price <= 0 ? "No estimation available to download" : "Download PDF report"}>
      <span>
        <Button
          startIcon={<GetAppIcon />}
          variant="contained"
          color="primary"
          fullWidth
          onClick={generatePDF}
          disabled={estimationcount.total_price <= 0}
          sx={{ borderRadius: '50px' }}
        >
          Report
        </Button>
      </span>
    </Tooltip>
  );
};

export default PDFGenerate;